const NAMESPACE = "pcCategorizedFilter";

const KEYS = {
    filtersHeader: "filtersHeader",
    selectAllFiltersButtonLabel: "selectAllFiltersButtonLabel",
    selectNoneFiltersButtonLabel: "selectNoneFiltersButtonLabel",
    selectAllButtonLabel: "selectAllButtonLabel",
    selectNoneButtonLabel: "selectNoneButtonLabel",
    resetFilterButtonLabel: "resetFilterButtonLabel",
    defaultItemsHeader: "defaultItemsHeader",
    defaultEmptyItemsText: "defaultEmptyItemsText",
    queryErrorDialogTitle: "queryErrorDialogTitle",
    queryErrorDialogText: "queryErrorDialogText",
    loadingIndicatorSRText: "loadingIndicatorSRText"
};

const MESSAGES = {
    [KEYS.filtersHeader]: {
        value: "Filters",
        comment: "Header text for section that displays categorized available filters."
    },
    [KEYS.selectAllFiltersButtonLabel]: {
        value: "Select all",
        comment: "Label for button that allows user to select all filters in a category."
    },
    [KEYS.selectNoneFiltersButtonLabel]: {
        value: "Select none",
        comment: "Label for button that allows user to deselect all filters in a category."
    },
    [KEYS.selectAllButtonLabel]: {
        value: "Select all",
        comment: "Label for button that allows user to select all visible items."
    },
    [KEYS.selectNoneButtonLabel]: {
        value: "Select none",
        comment: "Label for button that allows user to deselect all visible items."
    },
    [KEYS.resetFilterButtonLabel]: {
        value: "Reset Filters",
        comment: "Label for button that resets all currently applied filters."
    },
    [KEYS.defaultItemsHeader]: {
        value: "Data",
        comment: "Header text for section that lists selectable items under current filters."
    },
    [KEYS.defaultEmptyItemsText]: {
        value: "No data available.",
        comment: "Text that appears in the available items area when no items are available under current filters."
    },
    [KEYS.queryErrorDialogTitle]: {
        value: "Query Failure",
        comment: "Title for dialog that appears when the query has failed unexpectedly."
    },
    [KEYS.queryErrorDialogText]: {
        value: "An unexpected error has been encountered when attempting to filter the list. You may wish to save your progress and before trying again.",
        comment: "Text that appears in the available items area when no items are available under current filters."
    },
    [KEYS.loadingIndicatorSRText]: {
        value: "Retrieving...",
        comment:
            "Text that appears to screen readers instead of the loading icon that indicates more items are currently being fetched."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
